import { useUpdateEffect } from 'ahooks';

/**
 * @description https://ahooks.js.org/hooks/use-update-effect
 */
export default useUpdateEffect;
